

import React, { useState, useEffect } from "react";
import {
  Button,
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";

const ParentMeetingAccordionHeader = ({ meeting }) => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getBaseLength = (width) => {
    if (width >= 360 && width < 550) return 32;
    if (width >= 550 && width < 1199) return 17;
    if (width >= 1199 && width < 1400) return 44;
    if (width >= 1400 && width < 1700) return 45;
    return 37;
  };

  const popoverHoverFocus = (title) => (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Body className="popover-body">{title}</Popover.Body>
    </Popover>
  );

  const baseLength = getBaseLength(screenSize);
  const sliceLength = Math.floor(screenSize / baseLength);
  const shortTitle =
    meeting?.title?.length > sliceLength
      ? meeting?.title.slice(0, sliceLength) + "..."
      : meeting?.title;

  return (
    <Accordion.Header className="agenda-accordioncss">
      <div className="header-meeting">
        <div className="d-flex g-10 last-min-resp-accordion-header">
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="top"
            overlay={popoverHoverFocus(meeting?.title)}
          >
            <span className="pre-wrap-text">
              Meeting Title: {shortTitle}
            </span>
          </OverlayTrigger>
        </div>
        {meeting?.meetingId && (
          <div>
            <span className="meeting-id">({meeting.meetingId})</span>
          </div>
        )}
      </div>
    </Accordion.Header>
  );
};

export default ParentMeetingAccordionHeader;

